import { render, staticRenderFns } from "./AdminAccMenu.vue?vue&type=template&id=4da78350&scoped=true&"
import script from "./AdminAccMenu.vue?vue&type=script&lang=js&"
export * from "./AdminAccMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccMenu.vue?vue&type=style&index=0&id=4da78350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da78350",
  null
  
)

export default component.exports